import {useMediaQuery, useTheme, withStyles} from "@material-ui/core";
import {withTranslation} from "react-i18next";
import {Doughnut} from "react-chartjs-2";
import React from "react";

const styles = {
    chart:{
        height: 400,
        maxWidth: 800,
        margin: "auto"
    }
}
function GameStatsDonutChart(props){
    const {data,t,classes} = props
    const dataCharts = {
        labels: Object.keys(data).map((status)=>data[status].label),
        datasets: [
            {
                data: Object.keys(data).map((status)=>data[status].count),
                backgroundColor: Object.keys(data).map((status)=>data[status].bgColor),
                borderColor: Object.keys(data).map((status)=>data[status].bdColor),
                borderWidth: 1,
            },
        ]
    }
    const dataChartsOptions = {
        aspectRatio: 2,
        maintainAspectRatio:false,
        responsive:true,
        legend: {
            display: true,
            position: "top",
            labels:{
                fontColor: "black",
                fontSize: 16
            }
        },
        tooltips: {
            backgroundColor: "#393939",
            bodyFontColor: "white",
            bodyFontSize: 14
        },
        title: {
            display: true,
            text: t("label.training_session.stats_status"),
            fontSize: 20,
            position: "top",
        },
        plugins: {
            datalabels: {
                display: true,
                labels: {
                    value: {
                        color: "black"
                    },
                    title: {
                        color: 'black'
                    }
                }
            },
        }
    }
    return <div className={classes.chart}>
        <Doughnut options={dataChartsOptions} data={dataCharts} />
    </div>;
}

export default withStyles(styles)(withTranslation()(GameStatsDonutChart))